// extracted by mini-css-extract-plugin
export default {"container":"header-module___container___e4d11359","title":"header-module___title___fc3e1895"};